import Cookies from 'js-cookie';

import { getRootDomain } from 'utilities';

export const CLIENT_ID_COOKIE = 'es_client_id';
export const CLIENT_SUBDOMAIN_COOKIE = 'es_client_subdomain';
export const USER_EMAIL_COOKIE = 'es_user_email_address';
export const USER_AUTH_TYPE_COOKIE = 'es_user_auth_type';
export const CONNECTION_CTA_COOKIE = 'es_connection_cta';

export const USER_AUTH_COOKIE_DAYS = 3;
export const WELCOME_COOKIE_DAYS = 30;
export const DEFAULT_COOKIE_DAYS = 365;

const getSetterOptions = (days = DEFAULT_COOKIE_DAYS) => {
  const domain = getRootDomain();
  const options = { expires: days, domain: `.${domain}`, secure: true };
  (options as any).SameSite = 'None';
  return options;
};

export default {
  set clientId(id: string) {
    Cookies.set(CLIENT_ID_COOKIE, id, getSetterOptions());
  },
  set clientSubdomain(subdomain: string) {
    Cookies.set(CLIENT_SUBDOMAIN_COOKIE, subdomain, getSetterOptions());
  },
  set userEmail(email: string) {
    Cookies.set(USER_EMAIL_COOKIE, email, getSetterOptions());
  },
  set userAuthType(authType: string) {
    Cookies.set(USER_AUTH_TYPE_COOKIE, authType, getSetterOptions(USER_AUTH_COOKIE_DAYS));
  },
  set connectionCta(value: string) {
    Cookies.set(CONNECTION_CTA_COOKIE, value, getSetterOptions(WELCOME_COOKIE_DAYS));
  },
  get clientId() {
    return Cookies.get(CLIENT_ID_COOKIE);
  },
  get clientSubdomain() {
    return Cookies.get(CLIENT_SUBDOMAIN_COOKIE);
  },
  get userEmail() {
    return Cookies.get(USER_EMAIL_COOKIE);
  },
  get userAuthType() {
    return Cookies.get(USER_AUTH_TYPE_COOKIE);
  },
  get connectionCta() {
    return Cookies.get(CONNECTION_CTA_COOKIE);
  },
  removeAll() {
    const domain = getRootDomain();
    const options = { domain: `.${domain}` };

    /**
     * USER_AUTH_TYPE_COOKIE intentionally not removed
     * Leaving it allows auth only users a better logout
     * experience
     */
    Cookies.remove(CLIENT_ID_COOKIE, options);
    Cookies.remove(CLIENT_SUBDOMAIN_COOKIE, options);
    Cookies.remove(USER_EMAIL_COOKIE, options);
    Cookies.remove(CONNECTION_CTA_COOKIE, options);
  },

  /**
   * Adapter for Amplify. The stock amplify interface does not set SameSite=None,
   * so these cookies fail lost when the site is loaded inside an iframe (meaning users
   * can't log in).
   * Setting sameSite to None does not represent an XSS risk because these cookies
   * are only used for local storage. (Apparently cookies are used because local
   * storage is deemed insecure - this seems like a hack to me)
   */
  esCookieStorage: {
    setItem(key: string, value: any) {
      return Cookies.set(key, value, getSetterOptions());
    },

    getItem(key: string) {
      return Cookies.get(key);
    },

    removeItem(key: string) {
      return Cookies.remove(key, getSetterOptions());
    },

    clear() {
      Object.keys(Cookies.get()).forEach(key => Cookies.remove(key));
      return {};
    },
  },
};
